import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Card.css';

const Card = ({ id, imageSrc, category, title, date }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/blog/${id}`); // Navigate to the blog post with the given id
  };

  return (
    <div className="card" onClick={handleClick} style={{ cursor: 'pointer' }}>
      <div className="card-image-container">
        <img src={imageSrc} alt={title} className="card-image" />
      </div>
      <div className="card-content">
      <div className="card-category">
        <span className="category-label">
          {category}
        </span>
      </div>
        <h3 className="card-title">{title}</h3>
        <div className="card-details"> 
          <span className="card-date">{date}</span>
        </div>
      </div>
    </div>
  );
};

export default Card;
